module.exports = __webpack_public_path__ + "static/media/lwAAHO1kd9.c868c3f3.png";